"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.downloadImg = exports.copyToClipboard = void 0;
const dom_to_image_1 = __importDefault(require("dom-to-image"));
const copyToClipboard = ({ dom }) => __awaiter(void 0, void 0, void 0, function* () {
    let isSuccess = true;
    dom_to_image_1.default
        .toBlob(dom, dtiProps(dom))
        .then((blob) => __awaiter(void 0, void 0, void 0, function* () {
        yield navigator.clipboard.write([
            new ClipboardItem({
                [blob.type]: blob
            })
        ]);
    }))
        .catch(() => {
        isSuccess = false;
    });
    return {
        isSuccess
    };
});
exports.copyToClipboard = copyToClipboard;
const downloadImg = ({ dom, title, type }) => __awaiter(void 0, void 0, void 0, function* () {
    let isSuccess = true;
    dom_to_image_1.default === null || dom_to_image_1.default === void 0 ? void 0 : dom_to_image_1.default[type === 'jpeg' ? 'toJpeg' : 'toPng'](dom, dtiProps(dom)).then(dataUrl => {
        const link = document.createElement('a');
        link.download = `${title}.${type}`;
        link.href = dataUrl;
        link.click();
    }).catch(() => {
        isSuccess = false;
    });
    return {
        isSuccess
    };
});
exports.downloadImg = downloadImg;
const dtiProps = (dom) => {
    return {
        height: (dom.offsetHeight * 8000) / dom.offsetWidth,
        width: (dom.offsetWidth * 8000) / dom.offsetWidth,
        style: {
            transform: 'scale(' + 8000 / dom.offsetWidth + ')',
            transformOrigin: 'top left',
            width: dom.offsetWidth + 'px',
            height: dom.offsetHeight + 'px'
        }
    };
};
